export const riskMatrix = {
  consequence: {
    label: "Conséquence",
    save: "Sauvegarder les conséquences",
  },
  probability: {
    label: "Probabilité",
    save: "Sauvegarder les probabilités",
  },
  riskLevel: {
    label: "Niveaux de risque",
    save: "Sauvegarder les niveaux de risque",
  },
  value: {
    label: "Valeur",
  },
  noRisk: "aucun risque",
};
